import { useState } from 'react';
import type { FunctionComponent } from 'react';

import type { ForwardProps } from '@pega/cosmos-react-core/lib/types';
import { FileInput, createUID } from '@pega/cosmos-react-core';
import type { FileInputProps } from '@pega/cosmos-react-core';

import type { MockFileItem } from './FileService.mock';

const MockFileInput: FunctionComponent<FileInputProps & ForwardProps> = () => {
  const [fileStore, setFileStore] = useState<MockFileItem[]>([]);
  const addedFilesHandler = (addedFiles: File[]) => {
    addedFiles.forEach((file: File) => {
      const id = createUID();
      setFileStore([
        ...fileStore,
        {
          id,
          thumbnail: file.type.startsWith('image') ? URL.createObjectURL(file) : undefined,
          name: file.name,
          category: 'category-1',
          format: 'png',
          File: file,
          onCancel: () => {}
        }
      ]);
    });
  };

  return <FileInput files={fileStore} onFilesAdded={addedFilesHandler} label='File input label' />;
};

export default MockFileInput;
